import { render, staticRenderFns } from "./list.vue?vue&type=template&id=dc4bf9fe&scoped=true"
import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=dc4bf9fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4bf9fe",
  null
  
)

export default component.exports